import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year3/Summer/Shape/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'Shape',
  field: 'Geometry',
  weeks: [8, 9],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(/* webpackChunkName: "Year3/Summer/Shape/1TurnsAndAngles" */ './1TurnsAndAngles')
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(/* webpackChunkName: "Year3/Summer/Shape/2RightAngles" */ './2RightAngles')
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(/* webpackChunkName: "Year3/Summer/Shape/3CompareAngles" */ './3CompareAngles')
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Summer/Shape/4MeasureAndDrawAccurately" */ './4MeasureAndDrawAccurately'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Summer/Shape/5HorizontalAndVertical" */ './5HorizontalAndVertical'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Summer/Shape/6ParallelAndPerpendicular" */ './6ParallelAndPerpendicular'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Summer/Shape/7RecogniseAndDescribe2DShapes" */ './7RecogniseAndDescribe2DShapes'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(/* webpackChunkName: "Year3/Summer/Shape/8DrawPolygons" */ './8DrawPolygons')
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year3/Summer/Shape/9RecogniseAndDescribe3DShapes" */ './9RecogniseAndDescribe3DShapes'
        )
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(/* webpackChunkName: "Year3/Summer/Shape/10Make3DShapes" */ './10Make3DShapes')
    })
  ]
});
export default Block;
